"use client"
export const SolidThemeLink = () => {
    return (
        <link id="theme-css" href={`/themes/solid-light-purple/theme.css`} rel="stylesheet"></link>
    )
}